import { render, staticRenderFns } from "./SalesContractForm.vue?vue&type=template&id=1981ef74&"
import script from "./SalesContractForm.vue?vue&type=script&lang=js&"
export * from "./SalesContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports